<template>
    <div class="trend">     
      <el-tabs v-model="activeName">
        <el-tab-pane label="按月" name="first">
          <div class="percent-input">
            <span class="trend-title">电力占比</span>
            <el-input disabled type="number" placeholder="请输入" v-model="powerT">
              <template slot="suffix">%</template>
            </el-input>
            <span class="trend-title">水占比</span>
            <el-input disabled type="number" placeholder="请输入" v-model="waterT">
              <template slot="suffix">%</template>
            </el-input>
            <span class="trend-title">燃气占比</span>
            <el-input disabled type="number" placeholder="请输入" v-model="gasT">
              <template slot="suffix">%</template>
            </el-input>
            <span class="trend-title">燃煤占比</span>
            <el-input disabled type="number" placeholder="请输入" v-model="coalT">
              <template slot="suffix">%</template>
            </el-input>
            <span class="trend-title">燃油占比</span>
            <el-input disabled type="number" placeholder="请输入" v-model="oilT">
              <template slot="suffix">%</template>
            </el-input>
          </div>
          <div v-for="(msg,index) in tableDate" :key="index" class="tab-table">
            <span class="trend-title">{{powerType[msg.type-1]}}</span>
            <el-select v-model="msg.collect" placeholder="请选择">
              <el-option
                v-for="tts in options"
                :key="tts.value"
                :label="tts.label"
                :value="tts.value">
              </el-option>
            </el-select>
            <table class="mytable">
              <thead>
                <tr>
                  <th style="width:6%;">月份</th>
                  <th v-for="(mon,index) in month" :key="index">{{mon}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="background:#203bd5;text-align:center">上年同期</td>
                  <td>
                    <el-input type="number" v-model="msg.oneData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.twoData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.threeData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.fourData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.fiveData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.sixData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.sevenData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.eightData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.nineData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.tenData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.elevenData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.twelveData" placeholder="请输入"></el-input>
                  </td>
                </tr>
                <tr>
                  <td style="background:#203bd5;text-align:center">本期</td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.oneData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.twoData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.threeData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.fourData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.fiveData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.sixData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.sevenData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.eightData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.nineData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.tenData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.elevenData" placeholder="请输入"></el-input>
                  </td>
                  <td>
                    <el-input type="number" v-model="msg.lastData.twelveData" placeholder="请输入"></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="last-save">
            <el-button size="small" :loading="saveLoading" type="primary" @click="saveTrend">保存</el-button>
          </div>
        </el-tab-pane>
        <el-tab-pane label="按日" name="second">
          <div v-for="(msg,index) in tableDateDay" :key="index" class="tab-table">
            <span class="trend-title">{{powerType[msg.type-1]}}</span>
            <el-select v-model="msg.collect" placeholder="请选择">
              <el-option
                v-for="tts in options"
                :key="tts.value"
                :label="tts.label"
                :value="tts.value">
              </el-option>
            </el-select>
            <table class="mytable">
              <thead>
                <tr>
                  <th style="width:6%;">天数</th>
                  <th v-for="(mon,index) in day" :key="index">{{mon}}</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style="background:#203bd5;text-align:center">上月同期</td>
                  <td v-for="(data,index) in msg.dayDates" :key="index">
                    <el-input type="number" v-model="data.sum" placeholder="请输入"></el-input>
                  </td>
                </tr>
                <tr>
                  <td style="background:#203bd5;text-align:center">本期</td>
                  <td v-for="(dataLast,index) in msg.dayDatesLast" :key="index">
                    <el-input type="number" v-model="dataLast.sum" placeholder="请输入"></el-input>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div class="last-save">
            <el-button size="small" :loading="saveLoadingDay" type="primary" @click="saveTrendDay">保存</el-button>
          </div>
        </el-tab-pane>
      </el-tabs> 
    </div>
</template>


<script>
import apis from '@/apis/power/power'
export default {
  data() {
    return {
      saveLoading:false,//提交按钮状态
      saveLoadingDay:false,//提交日数据按钮状态
      activeName:'first',//tab切换

      powerT: '',
      waterT: '',
      gasT: '',
      coalT: '',
      oilT: '',
      powerType:['电力(KWH)','水(T)','燃气(方)','燃煤(T)','燃油(L)'],

      options: [{
        value: 0,
        label: '从后台获取'
      }, {
        value: 1,
        label: '手工录入'
      }],

      //通用循环数据
      month:['1月','2月','3月','4月','5月','6月','7月','8月','9月','10月','11月','12月'],
      day:['1','2','3','4','5','6','7','8','9','10','11','12','13','14','15','16','17','18','19','20','21','22','23','24','25','26','27','28','29','30','31'],
      tableDate:[
        {
          type:1,
          collect	:1,
          oneData:'',
          twoData:'',
          threeData:'',
          fourData:'',
          fiveData:'',
          sixData:'',
          sevenData:'',
          eightData:'',
          nineData:'',
          tenData:'',
          elevenData:'',
          twelveData:'',
          lastData:{
            id:'',
            oneData:'',
            twoData:'',
            threeData:'',
            fourData:'',
            fiveData:'',
            sixData:'',
            sevenData:'',
            eightData:'',
            nineData:'',
            tenData:'',
            elevenData:'',
            twelveData:'',   
          }
        },
        {
          type:2,
          collect	:1,
          oneData:'',
          twoData:'',
          threeData:'',
          fourData:'',
          fiveData:'',
          sixData:'',
          sevenData:'',
          eightData:'',
          nineData:'',
          tenData:'',
          elevenData:'',
          twelveData:'',
          lastData:{
            id:'',
            oneData:'',
            twoData:'',
            threeData:'',
            fourData:'',
            fiveData:'',
            sixData:'',
            sevenData:'',
            eightData:'',
            nineData:'',
            tenData:'',
            elevenData:'',
            twelveData:'',   
          }
        },
        {
          type:3,
          collect	:1,
          oneData:'',
          twoData:'',
          threeData:'',
          fourData:'',
          fiveData:'',
          sixData:'',
          sevenData:'',
          eightData:'',
          nineData:'',
          tenData:'',
          elevenData:'',
          twelveData:'',
          lastData:{
            id:'',
            oneData:'',
            twoData:'',
            threeData:'',
            fourData:'',
            fiveData:'',
            sixData:'',
            sevenData:'',
            eightData:'',
            nineData:'',
            tenData:'',
            elevenData:'',
            twelveData:'',   
          }
        },
        {
          type:4,
          collect	:1,
          oneData:'',
          twoData:'',
          threeData:'',
          fourData:'',
          fiveData:'',
          sixData:'',
          sevenData:'',
          eightData:'',
          nineData:'',
          tenData:'',
          elevenData:'',
          twelveData:'',
          lastData:{
            id:'',
            oneData:'',
            twoData:'',
            threeData:'',
            fourData:'',
            fiveData:'',
            sixData:'',
            sevenData:'',
            eightData:'',
            nineData:'',
            tenData:'',
            elevenData:'',
            twelveData:'',   
          }
        },
        {
          type:5,
          collect	:1,
          oneData:'',
          twoData:'',
          threeData:'',
          fourData:'',
          fiveData:'',
          sixData:'',
          sevenData:'',
          eightData:'',
          nineData:'',
          tenData:'',
          elevenData:'',
          twelveData:'',
          lastData:{
            id:'',
            oneData:'',
            twoData:'',
            threeData:'',
            fourData:'',
            fiveData:'',
            sixData:'',
            sevenData:'',
            eightData:'',
            nineData:'',
            tenData:'',
            elevenData:'',
            twelveData:'',   
          }
        },
      ],
      tableDateDay:[
        {
          type:1,
          collect	:1,
          dayDates:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}],
          dayDatesLast:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}]
        },
        {
          type:2,
          collect	:1,
          dayDates:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}],
          dayDatesLast:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}]
        },
        {
          type:3,
          collect	:1,
          dayDates:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}],
          dayDatesLast:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}]
        },
        {
          type:4,
          collect	:1,
          dayDates:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}],
          dayDatesLast:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}]
        },
        {
          type:5,
          collect	:1,
          dayDates:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}],
          dayDatesLast:[{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''},{sum:''}]
        },
      ]
    }
  },
  mounted() {
    this.getList('','')
    this.getListDay('','')
  },
  methods: {
    //获取数据
    getList(ect,pe){
      apis.getBatch({
        collect:ect,
        type:pe,
        time:new Date().getFullYear()
      }).then(res=>{
        if(res.code==10000){
          let _data = res.data
          let total = _data.zb.total
          if(_data.data.length!=0){
            // for(var i in this.tableDate){
            //   for(var j in _data.data){
            //     if(this.tableDate[i].type==_data.data[j].type){
            //       this.tableDate[i] = _data.data[j]
            //     }else{
            //       continue
            //     }
            //   }
            // }
            this.tableDate = _data.data
            this.powerT = (_data.zb.power/total*100).toFixed(2)
            this.waterT = (_data.zb.water/total*100).toFixed(2)
            this.gasT = (_data.zb.gas/total*100).toFixed(2)
            this.coalT = (_data.zb.coal/total*100).toFixed(2)
            this.oilT = (_data.zb.oil/total*100).toFixed(2)
          }
        }else{
          this.$message.error(res.message);
          return;
        }
      })
    },
    //获取日数据走势
    getListDay(){
      apis.getTrendDayList().then(res=>{
        if(res.code==10000){
          if(res.data){
            this.tableDateDay = JSON.parse(res.data.jsonData)
          }
        }
      })
    },
    //保存数据
    saveTrend(){
      this.saveLoading = true;
      apis.saveOrUpdateBatch(this.tableDate).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.saveLoading = false
          this.getList('','')
        }else{
          this.saveLoading = false
          this.$message.error(res.message)
          return;
        }
      })
    },
    //保存日数据
    saveTrendDay(){
      this.saveLoadingDay = true;
      let _json = JSON.stringify(this.tableDateDay)
      apis.saveTrendDaySave(
        {jsonData:_json}
      ).then(res=>{
        if(res.code==10000){
          this.$message.success('保存成功');
          this.saveLoadingDay = false
          this.getListDay()
        }else{
          this.saveLoadingDay = false
          this.$message.error(res.message)
          return;
        }
      })
    },
    // trendChange(a){
    //   this.getList(a,'')
    // },
  }
}
</script>
<style lang="less" scoped>
.trend{
  .percent-input{ margin-bottom: 15px;
    .trend-title{ width: auto;}
    .el-input{ margin-right: 15px; display: inline-block; width: 10rem;}
  }
  .tab-table{ margin-bottom: 15px;
    .trend-title{ width: 8.35rem; text-align: right;}
    .el-select{ display: inline-block; width: 10rem;}
  }
}
</style>


